module.exports = __webpack_public_path__ + "static/gull-zoom-685d186f3561f5cbba9358f82b3a6a9f.jpg";